import styled from 'styled-components';

const List = styled('ul')`
	flex: 1 1 auto;
	display: flex;
	flex-wrap: wrap;
	align-content: flex-start;
	margin: 0;
	padding: 15px 25px 8px;
	list-style-type: none;
`;

export {
	List,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/CombinePanel/SpreadsSelector/Grid/styles.ts